import _ from 'lodash'
import moment from 'moment-timezone'

const MINUTE_SECONDS = 60

export function getHourMinutes(rawSeconds = 0) {
    const duration = moment.duration(rawSeconds, 'seconds')
    const hours = Math.floor(duration.asHours())
    const minutes = duration.minutes()
    const seconds = duration.seconds()
    const mins = Math.round(minutes + seconds / MINUTE_SECONDS)

    return `${_.padStart(String(hours), 2, '0')}:${_.padStart(
        String(mins),
        2,
        '0',
    )}`
}

export function getHourMinutesCeil(rawSeconds = 0) {
    const duration = moment.duration(rawSeconds, 'seconds')
    const hours = Math.floor(duration.asHours())
    const minutes = duration.minutes()
    const seconds = duration.seconds()
    const mins = Math.ceil(minutes + seconds / MINUTE_SECONDS)

    return `${_.padStart(String(hours), 2, '0')}:${_.padStart(
        String(mins),
        2,
        '0',
    )}`
}

export function getSeconds(hourMinuteString) {
    const splitString = hourMinuteString.split(':')
    const SEC_MIN_HRS = 60

    return (
        parseInt(splitString[1] || 0, 10) * SEC_MIN_HRS +
        parseInt(splitString[0] || 0, 10) * SEC_MIN_HRS * SEC_MIN_HRS
    )
}
